module.exports = __webpack_public_path__ + "img/ezcare-logo.920ddadc.png";